export const localStorageKeys = {
  accessToken: "rentisity-accessToken",
  user: "rentisity-user",
};
export const SOCKET_API_CONFIG = "https://api-rentisity.intosoft.com/";
